/* link-new.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./link-new.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Anchor } from '@atlaskit/primitives/compiled';
var styles = {
  anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c81kw7 _syaz1fxt _9oik1r31 _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};

/**
 * __Progress tracker link__
 */
var Link = function Link(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    label = _ref.label,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Anchor, {
    xcss: styles.anchor
    // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
    ,
    href: href || '',
    onClick: onClick,
    testId: testId
  }, label);
};
export default Link;